import { ref as s, computed as B, onMounted as S, provide as D, withDirectives as E, openBlock as f, createElementBlock as m, normalizeClass as n, createVNode as F, unref as h, createCommentVNode as L, renderSlot as a, createElementVNode as l, normalizeStyle as b } from "vue";
import { themeProp as A, themeOptions as C } from "../../composables/useTheme.js";
/* empty css                 */
import N from "../../molecules/placeholder-loader/placeholder-loader.vue.js";
import { scrollAwds as V } from "../../utils/directives/scroll.js";
const j = { class: "ds-page-layout__content" }, G = { class: "ds-page-layout__footer" }, I = { class: "ds-page-layout__overlay" }, y = 72, M = /* @__PURE__ */ Object.assign({
  name: "DsPageLayout"
}, {
  __name: "page-layout",
  props: {
    ...A,
    preventTransition: {
      type: Boolean,
      default: !1
    },
    // Hides loading screen
    preventLoading: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["transition-prevented"],
  setup(d, { emit: g }) {
    const i = s(!1), o = s(!1), t = s(!1), r = s(!1), u = s(!1), _ = g, c = d, H = V(), T = B(() => t.value && !o.value ? C.light : c.theme);
    S(() => {
      i.value = !1;
    });
    const $ = ({ currentPosition: e, lastPosition: v }) => {
      const k = e > y;
      if (!(e < 0)) {
        if (c.preventTransition) {
          _("transition-prevented");
          return;
        }
        if (u.value) {
          z(), e === 0 && p(!0);
          return;
        }
        v > e ? p(e === 0) : k && w(e === y + 1);
      }
    }, p = (e) => {
      r.value = !e, e && (t.value = !1), o.value = !1;
    }, w = (e) => {
      o.value || (o.value = !0, t.value = !0, r.value = e);
    }, z = () => {
      o.value = !1, t.value = !0, r.value = !0;
    };
    return D("updateHeaderFreezeTransition", (e) => {
      u.value = e;
    }), (e, v) => E((f(), m("div", null, [
      d.preventLoading ? L("", !0) : (f(), m("div", {
        key: 0,
        class: n(["ds-page-layout-layover no-script--hidden", { "ds-page-layout-layover--show": i.value }])
      }, [
        F(h(N), { class: "ds-page-layout-layover__placeholder" })
      ], 2)),
      a(e.$slots, "cookie-bar"),
      l("div", {
        class: n(["ds-page-layout", `ds-page-layout--${e.theme}`]),
        style: b(e.theme === "custom" && { backgroundColor: e.customTheme })
      }, [
        l("header", {
          class: n(["ds-page-layout__header", [
            { "ds-page-layout__header--hidden": o.value },
            { "ds-page-layout__header--fixed": t.value },
            { "ds-page-layout__header--transition": r.value }
          ]])
        }, [
          a(e.$slots, "header", { headerTheme: T.value })
        ], 2),
        l("main", j, [
          a(e.$slots, "content")
        ]),
        l("footer", G, [
          a(e.$slots, "footer")
        ]),
        a(e.$slots, "cookie-bar-footer"),
        l("div", I, [
          a(e.$slots, "overlay")
        ])
      ], 6),
      a(e.$slots, "default")
    ])), [
      [h(H), $]
    ]);
  }
}), Q = M;
export {
  Q as default
};
